import { render, staticRenderFns } from "./ExpendableDiv.vue?vue&type=template&id=6bff6ae8&scoped=true"
import script from "./ExpendableDiv.vue?vue&type=script&lang=js"
export * from "./ExpendableDiv.vue?vue&type=script&lang=js"
import style0 from "./ExpendableDiv.vue?vue&type=style&index=0&id=6bff6ae8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bff6ae8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bff6ae8')) {
      api.createRecord('6bff6ae8', component.options)
    } else {
      api.reload('6bff6ae8', component.options)
    }
    module.hot.accept("./ExpendableDiv.vue?vue&type=template&id=6bff6ae8&scoped=true", function () {
      api.rerender('6bff6ae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/components/ExpendableDiv.vue"
export default component.exports